import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useContext = () => {
  const { t } = useTranslation("dialogs");

  return useMemo(
    () => ({
      maxWidth: "33.375rem",
      title: t("basemapSettings.basemapSettings"),
    }),
    [t],
  );
};
